import { render, staticRenderFns } from "./premiumBill.vue?vue&type=template&id=8fe167c4&scoped=true&"
import script from "./premiumBill.vue?vue&type=script&lang=js&"
export * from "./premiumBill.vue?vue&type=script&lang=js&"
import style0 from "./premiumBill.vue?vue&type=style&index=0&id=8fe167c4&prod&lang=scss&scoped=true&"
import style1 from "./premiumBill.vue?vue&type=style&index=1&id=8fe167c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe167c4",
  null
  
)

export default component.exports